// packages/common/config/typography.ts
import { TypographyVariantsOptions } from '@mui/material/styles';
import { typographyConstants } from '@assetron/common/constants/typographyConstants';

interface ExtendedTypographyVariantsOptions extends TypographyVariantsOptions {
  large_heading_38: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  large_heading_30_regular?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  large_heading_30_semibold?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  heading_24_regular?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  heading_24_semibold?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  heading_20_medium?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  heading_20_semibold?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  subheading_16_regular?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  subheading_16_medium?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  subheading_16_semibold?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_14_light?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_14_regular?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_14_medium?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_14_semibold?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_14_bold?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_12_light?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_12_regular?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_12_medium?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_12_semibold?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_12_bold?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_10_regular_uppercase?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_10_medium?: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_8_regular: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
  body_8_medium: {
    fontSize: string;
    fontWeight: number;
    lineHeight: number;
  };
}

export default function Typography(): ExtendedTypographyVariantsOptions {
  return {
    htmlFontSize: typographyConstants.htmlFontSize,
    fontFamily: typographyConstants.fontFamily,
    fontWeightLight: typographyConstants.fontWeightLight,
    fontWeightRegular: typographyConstants.fontWeightRegular,
    fontWeightMedium: typographyConstants.fontWeightMedium,
    fontWeightBold: typographyConstants.fontWeightBold,
    large_heading_38: typographyConstants.large_heading_38,
    large_heading_30_regular: typographyConstants.large_heading_30_regular,
    large_heading_30_semibold: typographyConstants.large_heading_30_semibold,
    heading_24_regular: typographyConstants.heading_24_regular,
    heading_24_semibold: typographyConstants.heading_24_semibold,
    heading_20_medium: typographyConstants.heading_20_medium,
    heading_20_semibold: typographyConstants.heading_20_semibold,
    subheading_16_regular: typographyConstants.subheading_16_regular,
    subheading_16_medium: typographyConstants.subheading_16_medium,
    subheading_16_semibold: typographyConstants.subheading_16_semibold,
    body_14_light: typographyConstants.body_14_light,
    body_14_regular: typographyConstants.body_14_regular,
    body_14_medium: typographyConstants.body_14_medium,
    body_14_semibold: typographyConstants.body_14_semibold,
    body_14_bold: typographyConstants.body_14_bold,
    body_12_light: typographyConstants.body_12_light,
    body_12_regular: typographyConstants.body_12_regular,
    body_12_medium: typographyConstants.body_12_medium,
    body_12_semibold: typographyConstants.body_12_semibold,
    body_12_bold: typographyConstants.body_12_bold,
    body_10_regular_uppercase: typographyConstants.body_10_regular_uppercase,
    body_10_medium: typographyConstants.body_10_medium,
    body_8_regular: typographyConstants.body_8_regular,
    body_8_medium: typographyConstants.body_8_medium,
  };
}
